import types from '../types';

import { getCheckboxGroupNextState, getResetedCheckboxGroupState } from '.';

/**
 * @typedef  Params
 * @type {Object}
 * @property {types.Filter[]} filters
 * @property {string} id
 * @property {string} filterId
 * @property {string} controlledFilterId
 */

/**
 * @param {Params}
 * @returns {types.Filter[]}
 */
const setFiltersCheckboxGroupState = ({
    filters,
    id,
    filterId,
    controlledFilterId
}) => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(filter => {
        if (filter.id === filterId && filter.type === 'checkbox') {
            const options = getCheckboxGroupNextState(filter.options, id);

            return {
                ...filter,
                options
            };
        }

        if (
            controlledFilterId &&
            filter.id === controlledFilterId &&
            filter.type === 'checkbox'
        ) {
            return {
                ...filter,
                options: getResetedCheckboxGroupState(filter.options)
            };
        }

        return filter;
    });
};

export default setFiltersCheckboxGroupState;
